import { t } from "@/i18n-js/instance";
import { BorderRadiusSelector } from "@circle-react-shared/BuilderUI/Editor/fields/BorderRadius";
import { EditorCollapsable } from "../../../../Editor/EditorCollapsable";
import type { ButtonVariant } from "./ButtonStateSelector";
import { generateFormItemName } from "./Styles";

interface CornersProps {
  selectedButtonVariant: ButtonVariant;
}
export const Corners = ({ selectedButtonVariant }: CornersProps) => (
  <EditorCollapsable
    title={t("builder_ui.prop_type.styles.corners")}
    defaultOpen
  >
    <div className="space-y-4 px-6 py-5">
      <BorderRadiusSelector
        name={generateFormItemName(selectedButtonVariant, "borderRadius")}
      />
    </div>
  </EditorCollapsable>
);
